
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const projects = [
  {
    title: '2026.03.04 Andrei Skopenko - You Build It, You Run It: The Pain & Power of On-Call',
    url: 'https://www.youtube.com/watch?v=5bD5Ex54l3U',
  },
  {
    title: '2023.03.30 Andrei Skopenko - Contribution score!',
    url: 'https://www.youtube.com/watch?v=pphMemu4ezM',
  },
  {
    title: '2022.04.21 Andrei Skopenko — Hire or die!',
    url: 'https://www.youtube.com/watch?v=OKLA9xwrJ7M',
  },
  {
    title: 'Andrei Skopenko shares his story as CTO of #NoOnes',
    url: 'https://www.youtube.com/watch?v=9rNROhBKtmE',
  }
];

const Projects: React.FC = () => {
  const getVideoId = (url: string) => {
    const regExp = /^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[1].length === 11) ? match[1] : null;
  };

  return (
    <section id="projects" className="py-5">
      <Container>
        <h2 className="text-center mb-4">YouTube Videos</h2>
        <Row>
          {projects.map((project, index) => {
            const videoId = getVideoId(project.url);
            return (
              <Col md={6} key={index} className="mb-4">
                {videoId && (
                  <div className="embed-responsive embed-responsive-16by9">
                    <iframe
                      className="embed-responsive-item"
                      src={`https://www.youtube.com/embed/${videoId}`}
                      allowFullScreen
                      title={project.title}
                    ></iframe>
                  </div>
                )}
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Projects;



